<footer
  class="container text-md-start text-center py-lg-5 pt-5"
  style="margin-top: -119px"
>
  <div class="row">
    <div class="col-xl-11 offset-xl-1">
      <p class="nav d-block fs-sm text-center text-md-start mb-0 mt-4 mt-lg-0">
        &copy; All rights reserved. Made by
        <a
          class="nav-link d-inline-block p-0"
          href="{{ creditsBy.website }}"
          target="_blank"
          rel="noopener"
          >{{ creditsBy.name }}</a
        >
      </p>
    </div>
  </div>
</footer>
